import { useEffect, useState } from 'react'

const STORAGE_KEY = 'fscr-launch-deadline'
const DURATION_MS = 24 * 60 * 60 * 1000

function getDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    const parsed = stored ? Number(stored) : NaN
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed
    const next = Date.now() + DURATION_MS
    window.localStorage.setItem(STORAGE_KEY, String(next))
    return next
  } catch {
    return Date.now() + DURATION_MS
  }
}

export type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

function format(msLeft: number): TimeLeft {
  const total = Math.max(0, Math.floor(msLeft / 1000))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) }
}

export function useCountdown(): TimeLeft {
  const [deadline] = useState<number>(() => getDeadline())
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() =>
    format(deadline - Date.now()),
  )

  useEffect(() => {
    const id = window.setInterval(() => {
      setTimeLeft(format(deadline - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  return timeLeft
}
